<epc-dynamic-collections-renderer
  class="d-contents"
  [items]="labelItems()"
></epc-dynamic-collections-renderer>
